import {
    FETCH_EVENTS,
    FETCH_EVENTS_SUCCESS,
    FETCH_EVENTS_FAILED,
    EDIT_EVENT
} from "../store/types";
import store from '../store/store';
import { firebase } from '../config/configureFirebase';
import { onValue, remove, push, set, child } from "firebase/database";
import { uploadBytesResumable, getDownloadURL } from "firebase/storage";

export const fetchEvents = () => (dispatch) => {
    const {
        eventsRef
    } = firebase;
    dispatch({
        type: FETCH_EVENTS,
        payload: null
    });
    onValue(eventsRef, snapshot => {
        if (snapshot.val()) {
            let data = snapshot.val();
            const arr = Object.keys(data).map(i => {
                data[i].id = i;
                return data[i]
            });
            dispatch({
                type: FETCH_EVENTS_SUCCESS,
                payload: arr
            });
        } else {
            dispatch({
                type: FETCH_EVENTS_FAILED,
                payload: store.getState().languagedata.defaultLanguage.no_address
            });
        }
    });
};

export const editEvent = (event, method) => async (dispatch) => {
    const {
        eventAddRef,
        eventImage,
        eventEditRef,
    } = firebase;
    dispatch({
        type: EDIT_EVENT,
        payload: { method, event }
    });

    if (method === 'Add') {
        const eventId = push(eventAddRef).key;
        await uploadBytesResumable(eventImage(eventId), event.image);
        let image = await getDownloadURL(eventImage(eventId));
        let data = event;
        data.image = image;
        set(child(eventAddRef, eventId), data);
    } else if (method === 'Delete') {
        remove(eventEditRef(event.id));
    } else {
        set(eventEditRef(event.id), event);
    }
}